<template>
  <div>
    <a-modal v-model="visible" title="等待支付" @ok="handleClose" @cancel="handleCancel" :footer="null" :width="300">
      <div style="width:100%;margin-bottom:20px;text-align:center">
        <img v-if="apiRes.payDataType == 'codeImgUrl'" :src="apiRes.payData" alt="">
        <span v-else-if="apiRes.payDataType == 'payurl'">等待用户支付 <hr> 如浏览器未正确跳转请点击： <a :href="apiRes.payData"
                                                                                      target="_blank">支付地址</a><a-button
            size="small" class="copy-btn" v-clipboard:copy="apiRes.payData" v-clipboard:success="onCopy">复制链接</a-button></span>
        <span v-else>等待用户支付,请稍后</span>
      </div>
      <p class="describe">
        <img src="@/assets/payTestImg/wx_app.svg" alt="" v-show="wxApp"><!-- 微信图标 -->
        <img src="@/assets/payTestImg/ali_app.svg" alt="" v-show="aliApp"><!-- 支付宝图标 -->
        <span>{{ payText }}</span>
      </p>
    </a-modal>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="提示信息" :visible.sync="dialogVisible"  width="30%" >
      <div id="successbox">

        <div v-if="ordertype == 2" class="infotip">感谢您订购自动化制图服务，当前订单已<span style="color: green">支付成功！</span>
          您的制图服务链接为: {{ sealurl }}，请妥善保存，此链接已发送至下单时填写的电子邮箱中。(本次链接可以使用三次服务)
          您可<span @click="openyw" style="color: red;cursor: pointer;">点击此处</span>立马使用制图服务。
        </div>

        <div v-if="ordertype == 4" class="infotip">
          感谢您订购人工制图服务，当前订单已<span style="color: green">支付成功！</span>购买本次服务可以制图<span style="color: red;">三张</span>。可直接在用户中心，点击上传需要制图图片，制图完成可点鼠标右键或点击下载图片保存图片。
        </div>
      </div>

<!--      <div id="successbox">-->
<!--        <div class="infotip">感谢您订购制图服务，当前订单已<span style="color: green">支付成功！</span>(本次服务可以处理<span style="color: green">三张</span>印章图片) 您可直接联系客服，使用制图服务。</div>-->
<!--        <div></div>-->
<!--      </div>-->

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closew">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import ReconnectingWebSocket from 'reconnectingwebsocket'
import {checkorderstatus, conf_list, getWebSocketPrefix} from '@/api/manage'

export default {
  name: 'PayTestModal',
  data() {
    return {
      sealurl: '',
      dialogVisible: false,
      visible: false,
      payText: '', // 二维码底部描述文字
      wxApp: false, // 微信二维码图片是否展示
      aliApp: false, // 支付宝二维码图片是否展示
      apiRes: {}, // 接口返回数据包
      payOrderWebSocket: null, // 支付订单webSocket对象
      configdata: {},
      ordertype:2,
      intervalId:null, // 定时器id
    }
  },
  created() {
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
    // conf_list({}).then(response => {
    //   this.configdata = response.data
    // })

  },
  methods: {
    openyw() {
      window.open(this.sealurl, '_blank')
    },
    onCopy() {
      this.$message.success('复制成功')
    },
    closew(){
      this.dialogVisible=false;
      window.location.reload();
    },
    // 二维码以及条码弹窗
    showModal(wayCode, apiRes) {
      const that = this
      this.apiRes = apiRes
      this.wxApp = false
      this.aliApp = false
      this.visible = true // 打开弹窗

      // 根据不同的支付方式，展示不同的信息
      this.payText = ''
      if (wayCode === 'WX_NATIVE' || wayCode === 'WX_JSAPI') { // 微信二维码
        this.wxApp = true
        this.payText = '请使用微信"扫一扫"扫码支付'
      } else if (wayCode === 'ALI_QR' || wayCode === 'ALI_JSAPI') { // 支付宝二维码
        this.aliApp = true
        this.payText = '请使用支付宝"扫一扫"扫码支付'
      } else if (wayCode === 'QR_CASHIER') { // 聚合支付二维码
        this.wxApp = true
        this.aliApp = true
        this.payText = '支持微信、支付宝扫码'
      }

      // 此处判断接口中返回的orderState，值为0，1 代表支付中，直接放行无需处理，2 成功 3 失败
      if (apiRes.orderState === 2 || apiRes.orderState === 3) {
        if (apiRes.orderState === 2) {
          that.handleClose()
          const succModal = that.$infoBox.modalSuccess('支付成功', <div>2s后自动关闭...</div>)
          setTimeout(() => {
            succModal.destroy()
          }, 2000)
          that.$emit('closeBarCode') // 关闭条码框
        } else if (apiRes.orderState === 3) {
          that.handleClose()
          that.$emit('closeBarCode') // 关闭条码框
          that.$infoBox.modalError('支付失败', <div>
            <div>错误码：{apiRes.errCode}</div>
            <div>错误信息：{apiRes.errMsg}</div>
          </div>)
        }
        return
      }

      // h5 或者 wap
      if (wayCode === 'WX_H5' || wayCode === 'ALI_WAP') {
        this.payText = '请复制链接到手机端打开'
      } else {
        // 跳转到PC网站
        if (apiRes.payDataType === 'payurl') {
          window.open(apiRes.payData)
        }
      }

      // 如果上面未关闭条码框，则代表进入webScoket，那么先在此处关闭条码框
      that.$emit('closeBarCode') // 关闭条码框
      // 1秒一次监听响应结果
      this.intervalId = setInterval(()=>{
        checkorderstatus({tradeno: apiRes.payOrderId}).then((res) => {
          switch (res.data.state) {
            case 2:
              that.handleClose()
              that.handleCancel()
              that.dialogVisible = true;
              that.ordertype = res.data.ordertype
              var str = this.configdata.paynotifyurl
              var arr = str.split("/prod");
              that.sealurl = arr[0] + '/#/stampui?sealcode='+res.data.sealcodestr
              break;
            case 0:

              break;
            default:
              that.handleClose()
                that.handleCancel()
              that.$infoBox.modalError('支付失败', <div>
                <div>错误码：{res.data.errCode}</div>
                <div>错误信息：{res.data.errMsg}</div>
              </div>)
          }
        })
      },1000)
    },
    handleCancel() {
      console.log('cancel')
      clearInterval(this.intervalId)
      this.intervalId = null
    },
    handleClose(e) {
      if (this.payOrderWebSocket) {
        this.payOrderWebSocket.close()
      }
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.describe {
  img {
    width: 30px;
    height: 25px;
  }
}

#successbox {
  .infotip {
    text-indent: 30px;
    line-height: 2
  }
}
</style>
